var { isBotRequest } = require("../../../../scripts/helpers/isBotRequest");
const cookieHelpers = require("../../../../scripts/helpers/cookieHelpers");
const { detectElement } = require("../helpers/domNodeObserver");
const accessibleDialog = require("../helpers/accessibleDialog");

const MODAL_KEY = "siteLocaleModalDismissed";

/**
 * This function adds the 'modal-open' class to the body to prevent background scrolling,
 * and sets the modal's CSS `display` property to "block", making it visible to the user.
 * It only performs these actions if the passed `localeModal` has at least one element.
 *
 * The modal is auto-launched with no triggering element, so it is opened through the accessible
 * dialog helper: focus moves to the close button, the rest of the page is made inert, and on
 * dismissal focus lands on the main landmark (DGF-3989).
 *
 * @param {jQuery} localeModal - A jQuery object representing the locale modal to be shown.
 */
function showModal(localeModal) {
    if (localeModal.length >= 1) {
        accessibleDialog.open(localeModal, {
            initialFocus: ".locale-modal-close",
            show: function (dialog) {
                $("body").addClass("modal-open");
                $(dialog).css("display", "block");
            },
            onClose: function (dialog) {
                $(dialog).remove();
                $("body").removeClass("modal-open");

                // Set here rather than in the click handler so dismissing with Escape is remembered too.
                cookieHelpers.setCookie(MODAL_KEY, "true", 3650);
            }
        });
    }
}

$(document).ready(async function () {
    if (isBotRequest(navigator.userAgent)) {
        return; // Don't show the modal to bots
    }

    var localeModal = $("#siteLocaleModal");

    // Check if user has already dismissed the modal via cookie
    if (cookieHelpers.getCookie(MODAL_KEY) === "true") {
        localeModal.remove();
        return;
    }

    // Cookie modal isn't dismissed
    if (!cookieHelpers.getCookie("OptanonAlertBoxClosed")) {
        await detectElement("onetrust-consent-sdk", document.body);

        $("#onetrust-accept-btn-handler, #accept-recommended-btn-handler").on("click", function () {
            showModal(localeModal);
        });
    } else {
        // Show the modal
        showModal(localeModal);
    }

    localeModal.on("click", ".locale-modal-close-link, .locale-modal-close", function (e) {
        e.preventDefault();
        accessibleDialog.close(localeModal);
    });
});
